import { render, staticRenderFns } from "./LongServiceLeaveSettings.vue?vue&type=template&id=ae4c9754"
import script from "./LongServiceLeaveSettings.vue?vue&type=script&lang=js"
export * from "./LongServiceLeaveSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports